module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "pre1"
    }
  }), _c('span', {
    staticClass: "big"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "space"
  }, [_vm._v("Preface to the Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Twelve years have passed since I stopped researching and writing the original "), _c('em', [_vm._v("Oceans of Kansas")]), _vm._v(". I was vaguely unsatisfied about not including all of the information that I wanted, but there had to be a stopping point in order to get the manuscript to the publisher. At the time, of course, I had no idea that I would have the opportunity to write a second edition and literally finish what I started. Since the original publication in 2005, many new discoveries have occurred in the Smoky Hill Chalk and other rocks deposited by the Western Interior Sea, and I’ve been fortunate to be able to collect and to describe my share of them. I’ve also benefited from the knowledge and experience of other paleontologists from outside Kansas and around the world in many co-authored papers. My research regarding the history of paleontology associated with the oceans of Kansas has also continued, and I have learned much more about the early collectors, as well as Cope and Marsh, and their discoveries in Kansas. The second edition presents a more complete view of the creatures that inhabited the oceans of Kansas during the Late Cretaceous, and also gives more credit to those less well known men who endured hardships on the Kansas prairie in the name of science. They are important because they represent the very beginnings of what we now consider to be modern paleontology. Amazingly, we are still finding new fossils in the Smoky Hill Chalk and experiencing some of the same thrills that I am sure were felt a hundred and fifty years ago.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648086ff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface01.vue
// module id = 78
// module chunks = 0